<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>縦軸1（棚割）： {{ y1 }}</div>
    <div>縦軸2（実績）： {{ y2 }}</div>
    <div>横軸（価格帯）： {{ unitPrice }}円刻み</div>
    <div>年代（集計）： {{ ageSummary.length }}年代</div>
    <div>年代（表示）： {{ ageDisplay.length }}年代</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 売場分析の「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    y1: {
      type: String,
    },
    y2: {
      type: String,
    },
    unitPrice: {
      type: Number,
    },
    ageSummary: {
      type: Array,
    },
    ageDisplay: {
      type: Array,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
